export default "__VITE_ASSET__BUlNo6kz__"